import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setOpen(true);
  }, []);

  // Auto-hide banner when user navigates to a legal page (so footer links work)
  useEffect(() => {
    if (location.pathname.startsWith("/legal/")) setOpen(false);
  }, [location.pathname]);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ status: "all", at: Date.now() }));
    setOpen(false);
  };
  const refuse = () => {
    localStorage.setItem(KEY, JSON.stringify({ status: "essential", at: Date.now() }));
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:bottom-6 sm:left-6 z-40 max-w-md"
      data-testid="cookie-banner"
    >
      <div className="rounded-2xl border border-slate-200 bg-white shadow-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-yellow-50 text-yellow-700 flex items-center justify-center shrink-0">
            <Cookie size={18} />
          </div>
          <div className="flex-1">
            <p className="font-display font-semibold text-slate-900">Cookies & confidentialité</p>
            <p className="text-sm text-slate-600 mt-1">
              Student Hub utilise uniquement des cookies essentiels (auth) et des préférences locales. Aucun tracker tiers.
              <Link to="/legal/cookies" className="text-indigo-600 hover:underline ml-1">En savoir plus</Link>
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="px-4 py-1.5 rounded-full bg-slate-900 text-white text-sm font-medium hover:bg-slate-800"
              >
                Tout accepter
              </button>
              <button
                onClick={refuse}
                data-testid="cookie-refuse"
                className="px-4 py-1.5 rounded-full bg-white border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50"
              >
                Essentiels uniquement
              </button>
            </div>
          </div>
          <button onClick={refuse} className="text-slate-400 hover:text-slate-600 shrink-0" data-testid="cookie-close">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
